import { render, staticRenderFns } from "./appConfirmation.vue?vue&type=template&id=89fd50fe&scoped=true&"
import script from "./appConfirmation.vue?vue&type=script&lang=js&"
export * from "./appConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fd50fe",
  null
  
)

export default component.exports